import type { IconData } from '@stacksjs/iconify-core'

export const id4x3: IconData = {
  "body": "<path fill=\"#e70011\" d=\"M0 0h640v240H0Z\"/><path fill=\"#fff\" d=\"M0 240h640v240H0Z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default id4x3
